import { Divider, Grid } from "@mui/material";
import { LaravelCategories, SLUG } from "helpers/helpers";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  useHistory,
  useRouteMatch,
} from "react-router-dom/cjs/react-router-dom.min";

/* Sections */
import { getModelsFromBrand } from "utils/LaravelApi/LaravelAPI";

export default function CategorySectionBrand() {
  const { brand, typeSlug } = useParams();

  const [availableModels, setAvailableModels] = useState([]);
  const [notAvailableModels, setNotAvailableModels] = useState([]);

  useEffect(() => {
    const category = LaravelCategories[SLUG[typeSlug]];
    const fetchModels = async () => {
      const models = await getModelsFromBrand(category, brand);
      if (models.success) {
        setAvailableModels(models.data.modelos_disponibles);
        setNotAvailableModels(models.data.modelos_no_disponibles);
      }
    };
    fetchModels();
  }, [brand, typeSlug]);

  return (
    <Grid container spacing={3} style={{ marginBottom: "30px" }}>
      {availableModels.map((model, idx) => {
        return (
          <>
            <Model idx={idx} model={model} />
            <Variantes model={model} />
          </>
        );
      })}
      <ModelsDivider />
      {notAvailableModels.map((model, idx) => {
        return (
          <>
            <Model idx={idx} model={model} />
            <Variantes model={model} />
          </>
        );
      })}
    </Grid>
  );
}

function ModelsDivider() {
  return (
    <Grid item sm={12}>
      <div style={{ textAlign: "center" }}>
        <Divider
          style={{
            marginTop: "30px",
            backgroundColor: "black",
            height: "1px",
            width: "50%", // Los Divider solo ocupan el 50% del ancho del Grid
            margin: "0 auto", // Centrar los Divider
          }}
        />
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
            fontSize: "25px",
          }}
        >
          Modelos no disponibles
        </div>
        <Divider
          style={{
            marginTop: "10px",
            backgroundColor: "black",
            height: "1px",
            width: "50%", // Los Divider solo ocupan el 50% del ancho del Grid
            margin: "0 auto", // Centrar los Divider
          }}
        />
      </div>
    </Grid>
  );
}

function Model({ idx, model }) {
  return (
    <Grid key={`model-${idx}`} item sm={12}>
      <Divider
        style={{
          marginTop: "30px",
          backgroundColor: "black",
          height: "1px",
          marginLeft: "5%",
          marginRight: "5%",
          marginBottom: "10px",
        }}
      />
      <div
        style={{
          textAlign: "left",
          marginLeft: "5%",
          fontFamily: "Poppins, sans-serif",
          fontWeight: "500",
          fontSize: "25px",
        }}
      >
        {" "}
        {model.nombre}{" "}
      </div>
      <Divider
        style={{
          marginTop: "10px",
          backgroundColor: "black",
          height: "1px",
          marginLeft: "5%",
          marginRight: "5%",
        }}
      />
    </Grid>
  );
}

function Variantes({ model }) {
  const history = useHistory();
  const { path } = useRouteMatch();
  const { typeSlug, brand } = useParams();

  const onClickHandle = (variant) => {
    const realPath = (path
    .replace(":typeSlug", typeSlug)
    .replace(":brand", brand)) 
    + `/${model.nombre}/${variant}`;

    history.push(realPath);
  };

  // Dividir las variantes en 3 columnas.
  const colCount = 3;
  const chunkedVariants = [];
  const variants = [...model.variantes].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  for (let i = 0; i < variants.length; i += colCount) {
    chunkedVariants.push(variants.slice(i, i + colCount));
  }

  return (
    <>
      {chunkedVariants.map((columnVariants, colIndex) => (
        <Grid container key={colIndex} item sm={4}>
          {columnVariants.map((variant, idx) => (
            <Grid
              key={`variant-${idx}`}
              item
              sm={12}
              style={{ color: "#bc0900" }}
            >
              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "900",
                  color: variant.disponible ? "#0000EE" : "black",
                  textDecoration: variant.disponible ? "none" : "line-through",
                  cursor: variant.disponible ? "pointer" : "default",
                }}
                onClick={variant.disponible ? () => onClickHandle(variant.name) : undefined}
              >
                {variant.name}
              </div>
            </Grid>
          ))}
        </Grid>
      ))}
    </>
  );
}
